export default [
  {
    title: 'travelExpenseEntry',
    path: '/travel-expense-request',
    icon: 'fa fa-paper-plane',
    active: true,
  },
  {
    title: 'travelExpensesViews',
    path: '/requests',
    icon: 'fa fa-list',
    active: false,
  },
  {
    title: 'reports',
    path: '/reports',
    icon: 'fa fa-pie-chart',
    active: false,
  },
  {
    title:'help',
    path: '/help',
    icon: 'fa fa-question-circle',
    active: false,
  },
];



// WEBPACK FOOTER //
// ./src/constants/pages.js